import { Trans } from '@lingui/macro'
import { ErrorLabel } from 'app/views/common-components/forms/ErrorLabel'
import React from 'react'
import DebouncedTextField from '../../common/DebouncedTextField'
import { isCustomFormulaValid } from './CustomConditionHelpers'

interface CustomConditionProps {
  /** Callback function triggered when the input value changes. */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void

  /** The current value of the expression input. */
  value: string

  /** List of conditions used to validate the custom formula. */
  conditions: any[]
}

/**
 * CustomCondition component that renders a text field for inputting a custom condition formula for a form element.
 *
 * @param {CustomConditionProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
const CustomCondition: React.FC<CustomConditionProps> = ({
  onChange,
  value,
  conditions
}: CustomConditionProps): JSX.Element => {
  const isError = Boolean(value) && !isCustomFormulaValid(value ?? '', conditions?.length)

  return (
    <DebouncedTextField
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={onChange}
      error={isError}
      helperText={isError &&
        <ErrorLabel label={<Trans>FORM_CONDITION_EDITOR_CUSTOM_FORMULA_FIELD_ERROR</Trans>} />}
    />
  )
}

export default CustomCondition
